var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GmapAutocomplete',{staticClass:"form-control",attrs:{"selectFirstOnEnter":true,"placeholder":_vm.placeholder},on:{"place_changed":_vm.setPlace},model:{value:(_vm.enderecoFormatado),callback:function ($$v) {_vm.enderecoFormatado=$$v},expression:"enderecoFormatado"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dbc6978","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/GoogleMapsAutocomplete.vue
// module id = 460
// module chunks = 6